import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import { Mutation, Getter } from 'vuex-class';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import InboxMessagesCount from '@/plugins/graphql/subscriptions/v3/inbox-messages-count.gql';
import UnreadMessagesCount from '@/plugins/graphql/queries/v3/unread-messages-count.gql';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import AppStatus from '@/plugins/graphql/queries/v3/app-status.gql';
import FormatNotificationCountMixin from '@/helpers/vue_mixins/FormatNotificationCountMixin';
import { NAV_DRAWER } from '@/helpers/constants/app';
let InboxWithNotificationCount = class InboxWithNotificationCount extends Mixins(ViewportSizeMixin, RouterParamsAppMixin, FormatNotificationCountMixin, AlertMixin) {
    constructor() {
        super(...arguments);
        this.appStatus = null;
        this.UnreadMessagesCount = 0;
        this.subscription = null;
    }
    initiateSubscription() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
        this.subscription = this.$apollo
            .subscribe({
            query: InboxMessagesCount,
            variables: {
                appGlobalId: this.$store.state.appGlobalId,
            },
        })
            .subscribe({
            next: ({ data }) => {
                this.UnreadMessagesCount = data.inboxMessagesCount?.messagesCount;
            },
            error(err) {
                console.error('Subscription error:', err);
            },
        });
    }
    async fetchAppStatus() {
        await this.$apollo
            .query({
            query: AppStatus,
            variables: {
                appUuid: this.appUUID,
            },
        })
            .then((result) => {
            this.appStatus = result?.data?.app;
        })
            .catch((e) => {
            this.errorNotification(e.message);
        });
    }
    async goToInboxManager() {
        await this.fetchAppStatus();
        const status = this.getAppStatus(this.appStatus);
        if (status === 'Active') {
            this.$router.push({
                name: 'inbox-manager',
                params: { uuid: this.appUUID, to: 'inbox-manager' },
            });
            this.showInbox(true);
            this.$store.commit('setSelectedFilter', 'all');
            return;
        }
        this.errorNotification(`Your app is ${status.toLowerCase()}. ${this.statusNotificationMessage(status)}`);
    }
    statusNotificationMessage(status) {
        switch (status) {
            case 'Under Maintenance':
                return 'Please disable the maintenance mode to use this feature.';
            case 'Unlaunched':
                return 'Please launch your app to use this feature.';
            default:
                return 'Please contact the ChatGenie support team.';
        }
    }
    getAppStatus(app) {
        const { status, maintenance } = app;
        if (status === 'Inactive') {
            return 'Disconnected';
        }
        if (maintenance) {
            return 'Under Maintenance';
        }
        return status;
    }
    mounted() {
        this.initiateSubscription();
        this.$apollo.queries.UnreadMessagesCount.refetch();
    }
};
__decorate([
    Mutation('showInbox', { namespace: NAV_DRAWER })
], InboxWithNotificationCount.prototype, "showInbox", void 0);
__decorate([
    Getter('showInbox', { namespace: NAV_DRAWER })
], InboxWithNotificationCount.prototype, "getInbox", void 0);
InboxWithNotificationCount = __decorate([
    Component({
        apollo: {
            UnreadMessagesCount: {
                query: UnreadMessagesCount,
                variables() {
                    return {
                        appUuid: this.$store.state.appUUID,
                    };
                },
                skip() {
                    return !this.$store.state.appUUID;
                },
                update(data) {
                    return data?.unreadMessagesCount;
                },
                subscribeToMore: {
                    document: InboxMessagesCount,
                    variables() {
                        return {
                            appGlobalId: this.$store.state.appGlobalId,
                        };
                    },
                    updateQuery(previousResult, { subscriptionData }) {
                        this.UnreadMessagesCount = subscriptionData.data.inboxMessagesCount.messagesCount;
                        return subscriptionData.data.inboxMessagesCount.messagesCount;
                    },
                },
            },
        },
    })
], InboxWithNotificationCount);
export default InboxWithNotificationCount;
